import PropTypes from 'prop-types';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import UILink from 'UIComponents/link/UILink';
import UILockBadge from 'UIComponents/badge/UILockBadge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CompareEmailsUpgradeButton({
  as,
  className,
  use,
  size,
  style,
  help
}) {
  const {
    openUpgradeModal
  } = useUpgradeModal('email-comparison-tool');
  const handleClick = event => {
    openUpgradeModal();
    event.stopPropagation();
  };
  if (as === 'button') {
    return /*#__PURE__*/_jsxs(UIButton, {
      "data-test-id": "compare-emails-upgrade-button",
      className: className
      // @ts-expect-error Type '(event: Event) => void' is not assignable to type 'MouseEventHandler<HTMLButtonElement>'.
      ,
      onClick: handleClick,
      size: size,
      style: style,
      use: use,
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "EmailComponents.header.compareEmails"
      }), /*#__PURE__*/_jsx(UILockBadge, {}), help]
    });
  }
  return (
    /*#__PURE__*/
    // @ts-expect-error Type '(event: Event) => void' is not assignable to type 'MouseEventHandler<HTMLAnchorElement>'.
    _jsxs(UILink, {
      "data-test-id": "compare-emails-upgrade-link",
      onClick: handleClick,
      children: [/*#__PURE__*/_jsx(UILockBadge, {}), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "EmailComponents.header.compareEmails"
      }), help]
    })
  );
}
CompareEmailsUpgradeButton.propTypes = {
  as: PropTypes.oneOf(['button', 'link']),
  className: PropTypes.string,
  size: PropTypes.string,
  style: PropTypes.string,
  use: PropTypes.string.isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
CompareEmailsUpgradeButton.defaultProps = {
  as: 'button',
  size: 'sm'
};
export default CompareEmailsUpgradeButton;